import React, { useRef, useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import IconSpace1 from "../assets/spaces-icons/1.png";
import IconSpace2 from "../assets/spaces-icons/2.png";
import IconSpace3 from "../assets/spaces-icons/3.png";
import IconSpace4 from "../assets/spaces-icons/4.png";
import IconSpace5 from "../assets/spaces-icons/5.png";
import IconSpace6 from "../assets/spaces-icons/6.png";
import IconSpace8 from "../assets/spaces-icons/8.png";
// removed waalego beta badge

import { setApp } from "../redux/auth/actions";
import api from "../services/api";
import BusinessUnitSelector from "./BusinessUnitSelector";

export const apps = [
  {
    id: "accounting",
    name: "Accounting",
    icon: IconSpace1,
    url: "/",
  },
  {
    id: "sourcing",
    name: "Sourcing",
    icon: IconSpace3,
    url: "/sourcing",
  },
  {
    id: "selecole",
    name: "Selecole",
    icon: IconSpace4,
    url: "/selecole",
    roles: ["super_admin", "admin", "user"],
  },
  {
    id: "rfp",
    name: "RFP",
    icon: IconSpace6,
    url: "/rfp",
    roles: ["super_admin", "admin", "user"],
  },
  {
    id: "githeo",
    name: "Githeo",
    icon: IconSpace5,
    url: "/githeo/campaigns",
    roles: ["super_admin", "admin", "user"],
  },
];

export default function AppSelector({ userId, sideBarOpen, setSideBarOpen, mode = "light" }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const selectedApp = useSelector((state) => state.Auth.app);
  const currentApp = apps.find((app) => app.id === selectedApp) || apps[0];
  const user = useSelector((state) => state.Auth.user);
  const filteredApps = apps.filter((app) => {
    if (user && user.role && app.roles?.length > 0) {
      return app.roles.includes(user.role);
    }
    return true;
  });

  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }

  function handleButtonClick() {
    if (!sideBarOpen) setSideBarOpen(true);
    openModal();
  }

  async function handleAppSelect(app) {
    dispatch(setApp(app.id));
    await api.put(`/user/${userId}`, { application: app.id });
    navigate(app.url);
    closeModal();
  }

  return (
    <>
      {sideBarOpen && (
        <div className={`w-full py-4 mb-4 mx-4 border-b ${mode === "light" ? "border-gray-200" : "border-gray-700/30"}`}>
          <div className="flex items-center gap-3 justify-center">
            <div className="relative flex items-center justify-center cursor-pointer" onClick={openModal}>
              <img
                src={currentApp.icon}
                alt="Logo"
                className={`w-10 h-10 object-cover rounded bg-transparent transition-all duration-200 border ${
                  mode === "light" ? "border-gray-300 hover:border-sky-500" : "border-gray-700 hover:border-gray-600"
                }`}
              />
            </div>
            <span className={`font-semibold font-gamja text-2xl ${mode === "light" ? "text-gray-700" : "text-gray-300"} uppercase tracking-wide`}>{currentApp.name}</span>
          </div>
          <div className="flex justify-center mt-3">
            <BusinessUnitSelector />
          </div>
        </div>
      )}
      <Modal isOpen={isOpen} onClose={closeModal}>
        <div className="rounded-xl p-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-10 max-w-2xl mx-auto justify-items-center">
            {filteredApps.map((app) => (
              <div
                key={app.id}
                className={`flex flex-col items-center cursor-pointer transition-all relative duration-300 transform hover:translate-y-[-5px]`}
                onClick={() => handleAppSelect(app)}>
                <div
                  className={`flex flex-col items-center p-2 rounded-lg mb-4 justify-center ${
                    app.id === selectedApp ? "bg-white border-4 border-sky-500 shadow-md" : "bg-white border border-gray-200 hover:border-blue-200"
                  }`}>
                  <img src={app.icon} alt={app.name} className="w-18 h-18 object-cover" />
                  
                </div>
                <span className="text-sm font-semibold text-center text-white uppercase tracking-wide">{app.name}</span>
              </div>
            ))}
          </div>
          <div className="flex flex-col items-center gap-4 mt-8">
            <button onClick={closeModal} className="text-sm text-gray-400 hover:text-gray-300 transition-colors duration-200 underline focus:outline-none">
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

function Modal({ isOpen, children, onClose = () => {}, className = "w-full h-full md:w-[90%] md:h-[90%]" }) {
  const cancelButtonRef = useRef();
  if (!isOpen) return <Fragment />;
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50 overflow-hidden bg-black/80 backdrop-blur-md" initialFocus={cancelButtonRef} open={isOpen} onClose={onClose}>
        <div className="min-h-screen flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95">
            <div className={`z-10 rounded-lg relative w-full h-full md:max-w-[90%] md:max-h-[90vh] ${className} overflow-auto`}>
              <div className="h-full">{children}</div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
